import { render, staticRenderFns } from "./upload-image-modal.vue?vue&type=template&id=b8e8582a&scoped=true"
import script from "./upload-image-modal.vue?vue&type=script&lang=js"
export * from "./upload-image-modal.vue?vue&type=script&lang=js"
import style0 from "./upload-image-modal.vue?vue&type=style&index=0&id=b8e8582a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e8582a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8e8582a')) {
      api.createRecord('b8e8582a', component.options)
    } else {
      api.reload('b8e8582a', component.options)
    }
    module.hot.accept("./upload-image-modal.vue?vue&type=template&id=b8e8582a&scoped=true", function () {
      api.rerender('b8e8582a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/ui/modals/upload-image-modal.vue"
export default component.exports